<template>
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#fa5a74h3ha)">
            <path d="M8 0C3.587 0 0 3.587 0 8s3.587 8 8 8 8-3.587 8-8-3.587-8-8-8z" fill="#fff"/>
            <path d="M8 13.333A5.333 5.333 0 1 0 8 2.666a5.333 5.333 0 0 0 0 10.667z" fill="#F29C24"/>
        </g>
        <defs>
            <clipPath id="fa5a74h3ha">
                <path fill="#fff" d="M0 0h16v16H0z"/>
            </clipPath>
        </defs>
    </svg>
</template>
